module.exports = __webpack_public_path__ + "img/3Fragezeichen.27887628.svg";